import React from 'react';
import PropTypes from 'prop-types';
import { formatCurrency, abbreviateFrequency } from '../../../utils/formatters';
import { isRequirementEffectiveForFortnight } from '../../../utils/requirementCalculations';

export const filterActiveAllocations = (allocations, fortnightStart, fortnightEnd) => {
  if (!fortnightStart || !fortnightEnd) {
    return allocations;
  }
  return allocations.filter((req) =>
    isRequirementEffectiveForFortnight(req, fortnightStart, fortnightEnd)
  );
};

/**
 * Minimal allocation list for quick "which bucket?" reference (no edit, dates, or status).
 */
const AllocationQuickList = ({ allocations, fortnightStart, fortnightEnd }) => {
  const active = filterActiveAllocations(allocations, fortnightStart, fortnightEnd);

  if (!active.length) {
    return <p className="text-muted small mb-0">No active allocations this fortnight.</p>;
  }

  return (
    <ul className="requirements-quick-list mb-0">
      {active.map((req) => {
        const freqAbbrev = abbreviateFrequency(req.frequency);
        return (
          <li key={req.id} className="requirements-quick-list-item">
            <div className="requirements-quick-list-line1">
              <span className="requirements-quick-list-name">{req.name}</span>
              <span className="requirements-quick-list-amount-freq text-muted">
                {formatCurrency(req.amount)}/{freqAbbrev}
              </span>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

AllocationQuickList.propTypes = {
  allocations: PropTypes.arrayOf(PropTypes.object).isRequired,
  fortnightStart: PropTypes.instanceOf(Date),
  fortnightEnd: PropTypes.instanceOf(Date),
};

export default AllocationQuickList;
